
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 5c-4.753 0-5.349.02-7.215.105-1.863.085-3.135.381-4.248.814a8.578 8.578 0 00-3.1 2.018 8.578 8.578 0 00-2.018 3.1c-.433 1.113-.729 2.385-.814 4.248C5.02 17.15 5 17.747 5 22.5s.02 5.349.105 7.215c.085 1.863.381 3.135.814 4.248a8.578 8.578 0 002.018 3.1 8.579 8.579 0 003.1 2.018c1.113.433 2.385.729 4.248.814 1.866.085 2.462.105 7.215.105s5.349-.02 7.215-.105c1.863-.085 3.135-.381 4.248-.814a8.579 8.579 0 003.1-2.018 8.579 8.579 0 002.018-3.1c.433-1.113.729-2.385.814-4.248.085-1.866.105-2.462.105-7.215s-.02-5.349-.105-7.215c-.085-1.863-.381-3.135-.814-4.248a8.579 8.579 0 00-2.018-3.1 8.578 8.578 0 00-3.1-2.018c-1.113-.433-2.385-.729-4.248-.814C27.85 5.02 27.253 5 22.5 5zm0 3.153c4.673 0 5.226.018 7.072.102 1.706.078 2.632.363 3.249.603.817.317 1.4.696 2.012 1.309a5.421 5.421 0 011.31 2.012c.239.617.524 1.543.602 3.25.084 1.845.102 2.398.102 7.071s-.018 5.226-.102 7.072c-.078 1.706-.363 2.632-.603 3.249a5.421 5.421 0 01-1.309 2.012 5.421 5.421 0 01-2.012 1.31c-.617.239-1.543.524-3.25.602-1.845.084-2.398.102-7.071.102s-5.226-.018-7.072-.102c-1.706-.078-2.632-.363-3.249-.603a5.421 5.421 0 01-2.012-1.309 5.422 5.422 0 01-1.31-2.012c-.239-.617-.524-1.543-.602-3.25-.084-1.845-.102-2.398-.102-7.071s.018-5.226.102-7.072c.078-1.706.363-2.632.603-3.249.317-.817.696-1.4 1.309-2.012a5.421 5.421 0 012.012-1.31c.617-.239 1.543-.524 3.25-.602 1.845-.084 2.398-.102 7.071-.102zm0 20.18a5.833 5.833 0 110-11.666 5.833 5.833 0 010 11.666zm0-14.82a8.986 8.986 0 100 17.973 8.986 8.986 0 000-17.972zm11.442-.355a2.1 2.1 0 11-4.2 0 2.1 2.1 0 014.2 0"}})])
          )
        }
      }
    